'use client';

import React, { useEffect } from 'react';
import { Loading } from 'react-simple-chatbot';
import { VetChatCheckoutMessage } from './components/VetChatCheckoutMessage';
import { useGetBreeds } from '../../../api/useGetBreeds';
import { UserStages } from '../../constants';
export type VetChatMessageContainerProps = {
  steps: Record<string, Record<'value', string>>;
  formatPetBreed: (value: string) => string;
  formatPetName: (value: string) => string;
  tryValidatingOrReturnFallbackBirthday: (value: string) => string;
};
export const VetChatCheckoutMessageContainer = ({
  steps,
  formatPetBreed,
  formatPetName,
  tryValidatingOrReturnFallbackBirthday
}: VetChatMessageContainerProps) => {
  const {
    data,
    query: getBreeds
  } = useGetBreeds();
  useEffect(() => {
    getBreeds();
  }, [getBreeds]);
  if (data?.success) {
    const {
      breeds
    } = data;
    const breedInput = formatPetBreed(steps[UserStages.ReplyPetBreed].value);
    const petBreed = breeds.find(breed => breed.includes(breedInput)) || 'Unknown';
    const petName = formatPetName(steps[UserStages.ReplyPetName].value);
    const petWeight = steps[UserStages.ReplyPetWeight].value;
    const petBirthday = tryValidatingOrReturnFallbackBirthday(steps[UserStages.ReplyPetBirthday].value);
    return <VetChatCheckoutMessage value={{
      name: petName,
      birthday: petBirthday,
      breed: petBreed,
      weight: String(petWeight)
    }} />;
  }
  return <Loading data-sentry-element="Loading" data-sentry-component="VetChatCheckoutMessageContainer" data-sentry-source-file="index.tsx" />;
};